import { useEffect, useState } from "react";

import { Destination } from "Constant/destination";

import {
    postSelectedOfflineToService,
    postSelectedPixelsToService,
} from "helpers/destinations/createDestination";

import SwalAlertComp from "components/SwalAlert";

import { TIKTOK_SELECTION_TYPES } from "../DestinationCreation.constants";

/**
 * TikTok Pixel / Web Events / Offline: OAuth (`CreateTikTokDestination`) then
 * advertiser pixel or event set selection (`TiktokCreateDest`).
 */
const useTiktokDestination = ({
    language,
    destinationCode,
    createPixelStatus,
    setSaveDisabled,
    setModalLoading,
    createDestinationAction,
}) => {
    const [hasAccess, setHasAccess] = useState(false);
    const [offlineData, setOfflineData] = useState();
    const [selectedValues, setSelectedValues] = useState([]);
    const [pixelsOption, setPixelsOption] = useState(null);

    useEffect(() => {
        if (!hasAccess || !TIKTOK_SELECTION_TYPES.includes(destinationCode)) {
            return;
        }
        setSaveDisabled(!selectedValues.length || !pixelsOption);
    }, [
        destinationCode,
        hasAccess,
        pixelsOption,
        selectedValues,
        setSaveDisabled,
    ]);

    const resetOnTypeChange = () => {
        setHasAccess(false);
        setSelectedValues([]);
        setPixelsOption(null);
    };

    const handleCreate = async () => {
        setModalLoading(true);

        if (selectedValues.length > 0) {
            const isOffline = destinationCode === Destination.ttoffline;
            const items = selectedValues.map((item) => ({
                advertiser_id: pixelsOption.id,
                [isOffline ? "event_set_id" : "pixel_id"]: item.id,
                type: destinationCode,
            }));
            const createPixel =
                createPixelStatus !== undefined ? createPixelStatus : false;
            const response = isOffline
                ? await postSelectedOfflineToService({
                      event_sets: items,
                      create_pixel: createPixel,
                  })
                : await postSelectedPixelsToService({
                      pixels: items,
                      create_pixel: createPixel,
                  });
            await createDestinationAction(response);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message:
                    language?.delete_swal_modal?.pixel_id_must_be_selected ??
                    "Pixel id must be selected",
                icon: "error",
            });
        }
        setModalLoading(false);
    };

    return {
        hasAccess,
        setHasAccess,
        offlineData,
        setOfflineData,
        selectedValues,
        setSelectedValues,
        pixelsOption,
        setPixelsOption,
        resetOnTypeChange,
        handleCreate,
    };
};

export default useTiktokDestination;
